import { cva } from '@vizit/theme';

const organizationTableWrapperClasses = cva({
  base: ['flex flex-col gap-4'],
});

const tableContainerClasses = cva({
  base: ['overflow-auto border border-secondary max-h-screen'],
});

const tableClasses = cva({
  base: ['w-full border-collapse'],
});

export { organizationTableWrapperClasses, tableContainerClasses, tableClasses };
